export const OmniVersions : string[]=["Adlink", "Siemens", "N/A"];